import React, {useEffect} from 'react';
import type {WithRouterProps} from 'react-router';

import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';

import {IN_APP_CALCULATOR_FLAG} from './useIsCalculatorAvailable';

/**
 * Layout for the `/calculator` route: while the `in_app_calculator` flag is off
 * (or still loading) it renders nothing and redirects away rather than expose
 * the tools. Gating the parent means every calculator child — including ones
 * added later — is covered without opting in.
 */
export function InAppCalculatorGate({
  children,
  router
}: React.PropsWithChildren<Pick<WithRouterProps, 'router'>>): React.JSX.Element | null {
  const {isFeatureEnabled, isLoading: isFlagLoading} =
    useIsFeatureFlagEnabled(IN_APP_CALCULATOR_FLAG);

  useEffect(() => {
    if (!isFlagLoading && !isFeatureEnabled) {
      router.replace('/');
    }
  }, [isFlagLoading, isFeatureEnabled, router]);

  if (isFlagLoading || !isFeatureEnabled) {
    return null;
  }

  return <>{children}</>;
}
